import { Injectable } from '@angular/core';
import { ICallableFunction, RequestService } from '@df/api/request/request.service';
import { NTrustPilot } from './trustpilot.namespace';

@Injectable({ providedIn: 'root' })
export class TrustpilotService {
    constructor(private requestService: RequestService) {}

    load(onSuccess?: ICallableFunction, onError?: ICallableFunction): void {
        this.requestService.loadScript(NTrustPilot.SCRIPT, {
            onLoad: onSuccess,
            onError: onError,
            reload: false,
        });
    }

    get api(): NTrustPilot.Api | undefined {
        if (typeof window !== 'undefined') {
            return window.Trustpilot;
        }
        return undefined;
    }

    get widgetManagement(): NTrustPilot.IWidgetManagementModule | undefined {
        if (typeof window !== 'undefined') {
            return window.Trustpilot?.Modules?.WidgetManagement;
        }
        return undefined;
    }
}
